import { defineComponent as _defineComponent } from 'vue'
import { BuilderFeatures } from "@/enums/BuilderFeatures";
  import { formatPrice as formatMeters } from "@/helpers/transformation/price";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";

  interface Props {
    currentFeature: BuilderFeatures;
    house: HouseDesignInterface;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorHouseFeaturesDesktop',
  props: {
    currentFeature: {},
    house: {}
  },
  emits: ["setCurrentFeature"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const setCurrentFeature = (feature: BuilderFeatures) => {
    emit("setCurrentFeature", feature);
  };

const __returned__ = { props, emit, setCurrentFeature, get BuilderFeatures() { return BuilderFeatures }, get formatMeters() { return formatMeters }, get HouseDesignInterface() { return HouseDesignInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})